import React from "react";
import {ListItemButton, ListItemText} from "@mui/material";
import {ISideBarItem} from "../../models/drawer";
import {useMatch, useNavigate, useResolvedPath} from "react-router-dom";

export default function OptionsMenu(props : ISideBarItem){

  const navigate = useNavigate();
  const resolvedPath = useResolvedPath(props.path);
  const match = useMatch({ path: resolvedPath.pathname, end: false });

  const handleClick = () => {
    navigate(props.path);
  };

  return(
    <ListItemButton
      selected={!!match}
      sx={{
        height: 60,
        "&.Mui-selected": {
          color : "#A9A9A9",
        },
      }}
      onClick={handleClick}
    >
      <div style={{margin: "0 5px 0 0"}}>
        {props.icon}
      </div>
      <ListItemText className="TextIcon" primary={props.label} />
    </ListItemButton>
  );
}
